module.exports = __webpack_public_path__ + "img/ikd.36708e90.png";